import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../colorVars';
import { cancelAllTradePlans } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/cancelAllTradePlans';
import { flattenAllTradePlans } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/flattenAllTradePlans';
import { pauseAllTradePlans } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/pauseAllTradePlans';
import { unpauseAllTradePlans } from '../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/unpauseAllTradePlan';
import { useWebsocketStore } from '../../../../../stores/websocketStore/websocketProvider';
import { MultiSwitch } from '../../../../atomic/buttons/multiSwitch/MultiSwitch';
import TextButton from '../../../../atomic/buttons/textButton/TextButton';
import { Heading4 } from '../../../../atomic/text/Text';
import style from './TradePlanGlobalControls.module.css';


export const TradePlanGlobalControls = ({ sortingKeyword, setSortingKeyword }) => {
  const { tradePlanStore } = useWebsocketStore();

  return (
    <div className={style.container}>
      <div className={style.header}>
        <Heading4 color={colors.lightGrey}>Active Trade Plans</Heading4>
        <div className={style.sorting}>
          <MultiSwitch
            margin="6px 0 0 10px"
            controlledValue={sortingKeyword}
            setValue={setSortingKeyword}
            labels={['Symbol', 'Status', 'Template', 'Creation Time']}
            values={['bySymbol', 'byStatus', 'byTemplate', 'byCreationTime']}
          />
        </div>
      </div>
      <div className={style.controls}>
        <TextButton
          clickHandler={pauseAllTradePlans}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.orange}
          width="fit-content"
        >
          PAUSE
        </TextButton>
        <TextButton
          clickHandler={unpauseAllTradePlans}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.green}
          width="fit-content"
        >
          UNPAUSE
        </TextButton>
        <TextButton
          clickHandler={cancelAllTradePlans}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.red}
          width="fit-content"
        >
          CANCEL
        </TextButton>
        <TextButton
          clickHandler={flattenAllTradePlans}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.red}
          width="fit-content"
        >
          FLATTEN
        </TextButton>
        <TextButton
          clickHandler={tradePlanStore.collapseAll}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.blue}
          width="fit-content"
        >
          COLLAPSE
        </TextButton>
        <TextButton
          clickHandler={tradePlanStore.expandAll}
          margin="0 5px 0 0"
          fontSize="medium"
          color={colors.lightGrey}
          backgroundColor={colors.blue}
          width="fit-content"
        >
          EXPAND
        </TextButton>
      </div>
    </div>
  );
};

TradePlanGlobalControls.propTypes = {
  setSortingKeyword: PropTypes.func,
  sortingKeyword: PropTypes.string,
  tradePlanIds: PropTypes.array
};

